<template>
    <div id="employment-details" class="employment-details-wrapper pt-8 scroll-mt-56">
        <HeadingBarComponent :step="2" />
        <div class="px-8">
            <h3 class="mb-4">Employment Details</h3>
            <div class="md:w-1/2 md:pr-6">
                <InputComponent label="Employment Status" :value="submission.employment_details.employment_status" />
                <InputComponent label="Employer's Name" :value="submission.employment_details.employer_name" />
                <InputComponent label="Occupation / Position" :value="submission.employment_details.occupation" />
                <InputComponent
                    label="Nature of Self Employment"
                    :value="submission.employment_details.nature_of_self_employment"
                />
                <InputComponent
                    label="Years at Current Employer"
                    :value="submission.employment_details.years_at_employer"
                />
            </div>
            <HrComponent />
            <div class="md:w-1/2 md:pr-6">
                <InputComponent label="Politically Exposed Person" :value="submission.employment_details.politically_exposed_person_details ? 'Yes' : 'No'" />
            </div>
            <InputComponent v-if="submission.employment_details.politically_exposed_person_details" label="Details" :value="submission.employment_details.politically_exposed_person_details" />
            <div class="md:w-1/2 md:pr-6">
                <InputComponent label="Professional Qualification" :value="submission.employment_details.professional_qualification_or_training_details ? 'Yes' : 'No'" />
            </div>
            <InputComponent v-if="submission.employment_details.professional_qualification_or_training_details" label="Details" :value="submission.employment_details.professional_qualification_or_training_details" />
            <HrComponent />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeadingBarComponent from "@adminComponents/misc/HeadingBarComponent";
import HrComponent from "@adminComponents/misc/HrComponent";
import InputComponent from "@adminComponents/inputs/InputComponent";

export default {
    name: "EmploymentDetailsComponent",
    components: {
        HeadingBarComponent,
        HrComponent,
        InputComponent,
    },
    computed: {
        ...mapGetters(["submission"]),
        currentAddress() {
            return this.submission.address.filter((address) => address.type == "Current")[0];
        },
        previousAddress() {
            return this.submission.address.filter((address) => address.type == "Previous")[0];
        },
        mailingAddress() {
            return this.submission.address.filter((address) => address.type == "Mailing")[0];
        },
    },
    data: function () {
        return {
            isLoading: false,
        };
    },
    methods: {
        // ...mapActions(["doLogout"]),
    },
};
</script>
